export const Delimiters = {
  Comma: ",",
  Semicolon: ";",
  Space: " ",
  Tab: "\t",
};
